import React, { useEffect, useState, useRef, useMemo } from 'react';
import { DateRangePicker, DateRangePickerProps } from 'rsuite5';
import { format as dateFormat } from 'date-fns';

export interface CustomDateRangePickerProps extends DateRangePickerProps {
  onChange?: (val: any[]) => void;
}

export default function CustomDateRangePicker({
  onChange,
  value = [] as any,
  ranges = [],
  format = 'yyyy-MM-dd HH:mm',
  ...props
}: CustomDateRangePickerProps) {
  const dateRangerRef = useRef(null);
  const [selectValue, setSelectValue] = useState<any>(value);

  useEffect(() => {
    if (selectValue.filter(Boolean).length === 2) {
      dateRangerRef?.current?.close();
    }
  }, [selectValue, dateRangerRef]);

  const placeholder = useMemo(() => {
    const [start, end] = selectValue;
    if (!start && !end) return ' ';
    return [start ? dateFormat(start, format) : '', end ? dateFormat(end, format) : ''].join('~');
  }, [selectValue, format]);

  return (
    <DateRangePicker
      ref={dateRangerRef}
      value={selectValue}
      ranges={ranges}
      format={format}
      menuClassName="custom-rs-date-ranger"
      onSelect={(date) => {
        // 判断选中的时间值
        setSelectValue((state) => {
          const [start, end] = state;
          if (!start) return [date, end];
          if (!end) return [start, date];
          return [date, null];
        });
      }}
      onClose={() => {
        if (!selectValue[1]) {
          // 当选择一个时间之后关闭
          setSelectValue(value);
          onChange(value);
        } else {
          const [start, end] = selectValue;
          onChange([dateFormat(start, format), dateFormat(end, format)]);
        }
      }}
      onClean={() => {
        setSelectValue([]);
        onChange([]);
      }}
      showOneCalendar
      {...props}
      placeholder={placeholder}
    />
  );
}
